/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var GetAllBondCompanies = require('../services/GetAllBondCompanies');
var GetSalesFinanceRenewalApplication = require('../services/GetSalesFinanceRenewalApplication');

var SalesFinanceRenewalApplication = require('../forms/SalesFinanceRenewalApplication');

module.exports = {
  event: 'build:license-renew:sales-finance',

  channel: 'nd:application',

  builder: function(config) {
    var defer = $.Deferred();
    $.when(GetAllBondCompanies(), GetSalesFinanceRenewalApplication(config.applicationId))
      .done(function(bondCompanies, renewalData) {
        defer.resolve(
          new SalesFinanceRenewalApplication({
            isReadOnly: config.isReadOnly,
            mode: config.mode || 'new', // new, resubmit, print or int-expand
            model: new Backbone.Model({
              bondCompanies: bondCompanies,
              renewalData: renewalData
            })
          })
        );
      })
      .fail(function(err) {
        defer.reject(err);
      });

    return defer.promise();
  }
};
